import { Text } from "@mantine/core";
import { useModals } from "@mantine/modals";
import { useNavigate } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
import { Check } from "tabler-icons-react";
import useMutateUserData from "./useMutateUserData";
import { deleteUser } from "../../api/users";

export default function useDeleteUser(navigateAway: boolean = false) {
  const modals = useModals();
  const navigate = useNavigate();

  const onSuccess = () => {
    showNotification({
      title: "User deleted",
      icon: <Check />,
      message: `The user has been deleted!`,
    });

    navigateAway && navigate(`/users`);
  };

  const onError = (error: string) => {
    showNotification({
      title: `Something went wrong`,
      message: `An error occurred while deleting the user(s). ${error}`,
      color: "red",
    });
  };

  const { mutate } = useMutateUserData(deleteUser, onSuccess, onError);

  const openModal = (ids: string[], onConfirm?: () => void) =>
    modals.openConfirmModal({
      centered: true,
      title: "Are you sure?",
      children: (
        <Text
          size="sm"
          sx={(theme) => ({
            color:
              theme.colorScheme === "dark"
                ? theme.colors.dark[0]
                : theme.colors["custom-gray"][0],
          })}
        >
          This action cannot be undone. Are you sure you want to delete{" "}
          {ids.length > 1 ? `these ${ids.length} users` : "this user"}?
        </Text>
      ),
      labels: { confirm: "Delete", cancel: "Cancel" },
      confirmProps: { color: "custom-red" },
      onCancel: () => {},
      onConfirm: async () => {
        await mutate(ids);
        onConfirm?.();
      },
    });

  return {
    openModal,
  };
}
